import { render, staticRenderFns } from "./secondStepToChannel.vue?vue&type=template&id=d7af5fec&scoped=true"
import script from "./secondStepToChannel.vue?vue&type=script&lang=js"
export * from "./secondStepToChannel.vue?vue&type=script&lang=js"
import style0 from "./secondStepToChannel.vue?vue&type=style&index=0&id=d7af5fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7af5fec",
  null
  
)

export default component.exports